// ----------------------------------------------------------------------

export default function Paper(theme) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: theme.palette.background.paper,
          // Common borderRadius for paper components
          borderRadius: theme.shape.borderRadius * 2,
        },
      },
    },
  };
}
